<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Non Resident Tax"
      text="Create Non Resident Tax"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="statusType"
              v-validate="'required'"
              :items="statusTypes"
              item-text="name"
              item-value="id"
              label="Type"
              :error-messages="errors.collect('statusType')"
              data-vv-name="statusType"  
              data-vv-as="status type"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="payrollPeriodStartMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="payrollPeriod"
                  v-validate="'required'"
                  :error-messages="errors.collect('payrollPeriod')"
                  data-vv-name="payrollPeriod"
                  data-vv-as="payroll period"
                  label="From payroll period"
                  outlined
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="payrollPeriod"
                type="month"
                no-title
                @input="payrollPeriodStartMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="percentage"
              v-validate="'required'"
              :rules="[rules.percentageRequired,rules.min,rules.max]"
              :error-messages="errors.collect('percentage')"
              data-vv-name="percentage"
              data-vv-as="percentage"
              outlined
              suffix="%"
              type="number"
              label="Percentage"
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="percentageLastForMonths"
              v-validate="'required'"
              :rules="[rules.percentageLastForMonthsRequired]"
              :error-messages="errors.collect('percentageLastForMonths')"
              data-vv-name="percentageLastForMonths"
              data-vv-as="percentage last for months"
              outlined
              suffix="Month(s)"
              type="number"
              label="Percentage Last For Months"
            />
          </v-col>
        </v-row>
      </v-container>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"       
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployeeUid: {
        type: String,
        required: true,
      },
    },
    
    data () {
      return {
        progressing: false,
        dialog: null,
        payrollPeriodStartMenu: false,
        payrollPeriod: null,
        percentage: null,
        percentageLastForMonths: null,
        rules: {
          percentageRequired: value => !!value || 'The percentage field is required',     
          percentageLastForMonthsRequired: value => !!value || 'The percentage last for months field is required',     
          min: value => value >= 0 || 'Minimum number is 0',      
          max: value => value <= 100 || 'Maximum number is 100',      
        },
        statusType: null,
        statusTypes: [
          { id: 'NON-RESIDENT', name: 'Non-Resident' },
          { id: 'REP', name: 'Returning Expert Program (REP)' },
          { id: 'IRDA', name: 'Knowledge Worker (IRDA)' },
          { id: 'C-SUITE', name: 'C Suite' },
        ],
      }
    },
    
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData() 
      },
    },

    methods: {
      prepareFormData () {
        return {
          statusType: this.statusType,
          percentage: this.percentage,
          percentageLastForMonths: this.percentageLastForMonths,
          payrollPeriod: this.payrollPeriod + '-01',
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            
            this.progressing = true
            
            this.$api.nonResidentTaxes().create(this.companyEmployeeUid, this.prepareFormData())
              .then(res => {
                this.$emit('created')                
                this.$snack({ message: res.data.status })
                
                this.progressing = false
                this.dialog = false
              })
          })
      },
    },
  
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
